import { AccountType } from "@syla/shared/types/models/AccountBase";

export const AccountTypeBadgeColorMap: Record<AccountType, string> = {
  [AccountType.Individual]: "gray",
  [AccountType.Trust]: "green",
  [AccountType.Company]: "blue",
  [AccountType.SMSF]: "purple",
};
